var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39,42 L3,42 C1.9,42 0,41.1 0,40 L0,30 C0,28.8954305 0.8954305,28 2,28 C3.1045695,28 4,28.8954305 4,30 L4,38 L36,38 L36,30 C36,28.8954305 36.8954305,28 38,28 C39.1045695,28 40,28.8954305 40,30 L40,40 C40,41.1 40.1,42 39,42 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.88,13.6 L22.26,0.56 L22.1,0.44 L22,0.32 L21.8,0.22 L21.66,0.22 L21.4,0 L21.26,0 L20.88,0 L20.5,0 L20.4,0 L20.12,0 L20.12,0 C19.9777616,0.0641236996 19.8435154,0.144671431 19.72,0.24 L19.72,0.24 L19.72,0.24 L6.1,13.58 C5.58911019,14.0801718 5.38386704,14.8149061 5.56158365,15.5074356 C5.73930026,16.199965 6.27297725,16.745078 6.96158366,16.9374356 C7.65019007,17.1297932 8.38911021,16.9401718 8.9,16.44 L18.9,6.72 L18.98,30 C18.98,31.1045695 19.8754305,32 20.98,32 L20.98,32 C22.0845695,32 22.98,31.1045695 22.98,30 L22.98,6.7 L33.2,16.48 C33.6785738,17.1234162 34.4951771,17.4187863 35.2746181,17.2304014 C36.0540592,17.0420164 36.6456266,16.4063022 36.7775222,15.6153403 C36.9094178,14.8243784 36.5561385,14.0311078 35.88,13.6 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.ca9c73d5e2a22a0cc32a449f82b44c45.svg";
export { ForwardRef as ReactComponent };